<template>
  <div class="title">密码登录</div>
  <el-form>
    <el-form-item>
      <el-input v-model="formData.phone" class="input_style vcc_input_style" @input="inputPhoneNum" @focus="inputFocus" @blur="inputBlur" placeholder="请输入手机号" size="large">
        <template #prepend>
          <el-select
            v-model="formData.zoneNum"
            placeholder="+86"
            size="large"
            placement="left-start"
            class="zone-select login-zone-select"
            popper-class="zone-select-popper"
            value-key="+86"
            :suffix-icon="iconDropDown"
            @change="changeZone"
          >
            <el-option
              v-for="item in areas"
              :label="item.code"
              :value="item.code"
              :key="item.code"
              >
              <div class="flexMainXcenter justify-between">
                <div>{{ item.text }} {{ item.code }}</div>
                <img v-if="formData.zoneNum == item.code" class="selected_icon" src="@/assets/images/login/gou.png" alt="">
              </div>
            </el-option>
          </el-select>
        </template>
        <template #prefix>
          <div class="input_v_line"></div>
        </template>
      </el-input>
    </el-form-item>

    <el-form-item>
      <div class="relative" style="width: 100%;">
        <el-input
          class="pwd_style"
          v-model="formData.password"
          :type="!showPwd?'password':'text'"
          placeholder="请输入密码"
          size="large"
          @focus="focusHandle"
          @blur="inputBlur"
        >
        </el-input>
        <div class="pwd_handle_box" v-if="isFocus && formData.password">
          <img @click.stop="clearPwd" class="clear_icon point" src="@/assets/images/login/clear_icon.svg" alt="">
          <img @click.stop="showPwd = true" v-if="!showPwd" class="eye_icon point" src="@/assets/images/login/close_eye.png" alt="">
          <img @click.stop="showPwd = false" v-if="showPwd" class="eye_icon point" src="@/assets/images/login/open_eye.png" alt="">
        </div>
      </div>
      
    </el-form-item>

    <el-button
      class="submit-btn"
      size="large"
      @click="doPwdlogin"
      type="primary"
      text
      bg
      >登录</el-button>

    <div class="mgt12">
      <el-button link @click="forgetPwdHandle">忘记密码</el-button>
      <el-button link class="float-right" @click="toVccLogin">手机验证码登录</el-button>
    </div>
  </el-form>

  <el-dialog
    v-model="showSetPwdMessageBox"
    width="400px"
    :show-close="false"
    top="32vh"
    >
    <template #header>
      <div class="dialog_header flexMainXYcenter justify-between">
        <div class="flexMainXYcenter">
          <img class="prompt_icon flexShrink" src="@/assets/images/layout/prompt_icon.png" alt="">
          <div class="tit" >手机号还未设置密码</div>
        </div>
        <img class="close_icon" @click.stop="showSetPwdMessageBox = false" src="@/assets/images/layout/close_icon.png" alt="">
      </div>
    </template>
    <div class="dialog_body">
      <div class="dialog_msg_login">请先设置密码或用手机验证码登录</div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button class="btn_120W normal_btn" @click="toPwdSet">设置密码</el-button>
        <el-button type="primary" class="btn_120W beauty_btn" style="margin-left: 12px;" @click="toVccLogin">验证码登录</el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 没点击同意协议 -->
  <agreementHandle ref="agreeModel" @canLogin="agreeHandle"/>
</template>
    
<script setup>
import areas from "@/utils/areas";
import requestApi from "@/api/index";
import { messageError } from '@/utils/message';
import { ref,onMounted,reactive, onBeforeUnmount } from "vue";
import iconDropDown from './IconDropDown.vue'
import agreementHandle from './agreementHandle.vue'; //
import { validatePhoneNumber } from "@/utils/common";
import { useLoginStore } from './store';
import bus from '@/utils/bus'
const props = defineProps([
  'ctxPhoneZone',
  'ctxPhoneNumber',
  'ctxAgreementCheckOut'
]);

const formData = reactive({ //表单
  zoneNum:'',
  phone:'',
  agreementCheckOut: false,//是否勾选了协议
  password:''
})



onMounted(()=> {
  PwdLoginInit();
  document.addEventListener('keydown', enterKeyDown)
  // 第一个参数：为事件的类型，第二个参数为事件的回调
  bus.on('agreement',(val)=> {   //on(收东西!!)
    console.log('val',val);
    formData.agreementCheckOut = val
  })
})

onBeforeUnmount(()=> {
  document.removeEventListener('keydown', enterKeyDown);
})

const loginStore = useLoginStore();
const agreeModel = ref(null); //
const showPwd = ref(false); //
const emits = defineEmits(['to','onLoginSuccess', 'focus', 'blur'])
const isFocus = ref(false);//是否聚焦
const showSetPwdMessageBox = ref(false)

const enterKeyDown = (event) =>{
  if(event.key == 'Enter'){
    doPwdlogin();
  }
}

// 初始化
const PwdLoginInit = () => {
  formData.zoneNum = props.ctxPhoneZone;
  formData.phone = props.ctxPhoneNumber;
  formData.agreementCheckOut = props.ctxAgreementCheckOut;
  console.log('formData',formData)
}

// 同意并执行登录
const agreeHandle = () =>{
  console.log('erre')
  formData.agreementCheckOut = true;
  loginStore.changeAgreementCheck(true)
  bus.emit('changeAgreement', true)
  doPwdlogin();
}

// 修改电话号码
const inputPhoneNum = (val) =>{
  loginStore.changePhoneNum(val);
}

// 清除密码
const clearPwd = () =>{
  formData.password = '';
}

// 聚焦显示
const focusHandle = () =>{
  isFocus.value = true;
  emits('focus')
}

const inputFocus = () => {
  emits('focus')
}

const inputBlur = () => {
  emits('blur')
}

// 
const validatePhone = () => {
  if (formData.phone == '') {
    messageError("请输入手机号", 40);
    return false;
  }

  if (validatePhoneNumber(formData.phone, formData.zoneNum) == false) {
    messageError("请输入正确的手机号码", 40);
    return false;
  }

  return true;
};

const validatePwd = () => {
  if(formData.password == ''){
    messageError("请输入密码", 40);
    return false;
  }
  return true
};

// 忘记密码
const forgetPwdHandle = () =>{
  emits('to',{
    model:'VccLoginForm',
    hasBack:true,
    hasAgreement:false,
    isForgetPwd:true
  })
};

// 登录
const doPwdlogin = () => {
  if (!validatePhone()) {
    return false;
  }
  if(!validatePwd()){
    return false
  }
  if(!formData.agreementCheckOut){
    agreeModel.value.agreeShow = true;
    return false;
  }
  requestApi.loginModule.pwdLogin({
    phone: formData.phone,
    zoneNum: formData.zoneNum,
    password: formData.password
  }).then((response) => {
    const result = response.data;
    console.log('result.data',result.data)
    if(result &&result.code == 200){
      const access = result.data;
      emits('onLoginSuccess',access,formData.phone,formData.zoneNum)
    }else if(result.code == 55013){ //未设置密码
      showSetPwdMessageBox.value = true;
      return false;
    }else if(result.code == 55003){ //未设置密码
      messageError('手机号未注册', 40);
      return false;
    }else{
      let errMsg = result.msg != undefined ? result.msg : "系统错误";
      messageError(errMsg, 40);
      return false;
    }

    
  }).catch(reason => {
    console.error(reason);
    messageError(reason, 40);
  });
  
};

// 修改区号
const changeZone = (val) =>{
  loginStore.changePhoneZone(val);
}


// 使用验证码登录
const toVccLogin = () =>{
  emits('to',{
    model:'VccLoginForm',
    hasBack:false,
    hasAgreement:true,
    isForgetPwd:false
  })
}

// 设置密码
const toPwdSet = () => {
  showSetPwdMessageBox.value = false;
  emits('to',{
    model:'VccCheckForm',
    hasBack:true,
    hasAgreement:true,
    isForgetPwd:false
  })
}

</script>

<style lang="scss" scoped>
  @import url(./styles/index.scss);
  .submit-btn {
    --el-button-hover-text-color: #ffffff;
    width: 100%;
    border-radius: 25px;
    font-size: 16px;
    height: 48px;
  }
  .pwd_handle_box{
    position: absolute;
    right: 16px;
    top: 14px;
    z-index: 9;
    .clear_icon{
      width: 20px;
      height: 20px;
    }
    .eye_icon{
      width: 20px;
      height: 20px;
      margin-left: 12px;
    }
  }
</style>